module.exports = __webpack_public_path__ + "exo-latin-500italic.bd17cb2d62c226e06fdb.woff";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-500italic.woff
// module id = ../../../../typeface-exo/files/exo-latin-500italic.woff
// module chunks = styles